import { render, staticRenderFns } from "./administratorsdia.vue?vue&type=template&id=9732ce34&scoped=true"
import script from "./administratorsdia.vue?vue&type=script&lang=js"
export * from "./administratorsdia.vue?vue&type=script&lang=js"
import style0 from "./administratorsdia.vue?vue&type=style&index=0&id=9732ce34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9732ce34",
  null
  
)

export default component.exports